import { Ref } from 'vue';

import BorrowingServices from '@/services/borrowing.service';

import { ToastMethod } from 'tsv2-library/dist/src/utils/toast.util';

import { ApprovalTransaction } from '@/types/approval.type';
import SettingTransactionServices from '@/services/setting-transaction.service';
import { SettingTransaction } from '@/types/setting-transaction.type';

/**
 * Get the approver list of the transaction from the server.
 */
const getApproverList = async (
  transactionId: Ref<string | undefined>,
  setLoading: (value: boolean) => void,
  approvalList: Ref<ApprovalTransaction[] | undefined>,
  toast: ToastMethod,
): Promise<void> => {
  if (!transactionId.value) return;
  try {
    setLoading(true);

    const { data } = await BorrowingServices.getApprovalList(
      transactionId.value,
    );

    approvalList.value = data.data;
  } catch (error) {
    toast.add({
      error,
      message: 'Error, failed to fetch approver list',
      severity: 'error',
    });
  } finally {
    setLoading(false);
  }
};

/**
 * Get the setting transaction data from the server.
 */
const getSettingTransactionData = async (
  setLoading: (value: boolean) => void,
  settingTransaction: Ref<SettingTransaction | undefined>,
  toast: ToastMethod,
): Promise<void> => {
  try {
    setLoading(true);

    const { data } = await SettingTransactionServices.getData();

    settingTransaction.value = data.data;
  } catch (error) {
    toast.add({
      error,
      message: 'Error, failed to fetch setting transaction',
      severity: 'error',
    });
  } finally {
    setLoading(false);
  }
};

export { getApproverList, getSettingTransactionData };
